<script lang="ts">
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import LocationPin from '@athena-lib/Icons/LocationPin.svelte';
  import { Text } from '@athena-lib/Text';

  type ShippingBannerProps = {
    openDeliveryDetails: () => void;
    postalCode?: string;
  };

  const { openDeliveryDetails, postalCode }: ShippingBannerProps = $props();

  const translations = getCommonTranslations();
</script>

<div class="flex items-center justify-between gap-2 bg-st-black px-6 py-2 text-st-white">
  <Text element="span" size="xsmall" color="light">{translations.deliveryTimeText}</Text>
  <button type="button" class="flex items-center gap-2" onclick={openDeliveryDetails}>
    <LocationPin sizeClass="size-4" />
    <Text element="span" size="xsmall" color="light">
      {translations.deliveringTo} <span class="font-bold text-st-blue-500">{postalCode}</span>
    </Text>
  </button>
</div>
